export const SHOW_COUPONS_BAR = "SHOW_COUPONS_BAR";
export const ACTIVATE_OVERLAY_MESSAGE = "ACTIVATE_OVERLAY_MESSAGE";
export const DEACTIVATE_OVERLAY_MESSAGE = "DEACTIVATE_OVERLAY_MESSAGE";
export const REFETCH_RECEIVED_COUPONS = "REFETCH_RECEIVED_COUPONS";
export const REFETCH_SENT_COUPONS = "REFETCH_SENT_COUPONS";
